import { useEffect, useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";
import PortalLayout from "@/components/PortalLayout";
import OrderSummary from "@/components/OrderSummary";
import api, { apiErr } from "@/lib/api";

export default function CustomerOrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/my/orders/${id}`);
      setOrder(data);
    } catch (e) { toast.error(apiErr(e)); }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  const onAccept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/my/orders/${id}/accept`);
      setOrder(data); toast.success("Quotation accepted");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  const onPay = async (amount) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/my/orders/${id}/pay`, { amount });
      setOrder(data); toast.success("Payment confirmed");
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  const shareLink = order ? `${window.location.origin}/q/${order.share_token}` : null;

  return (
    <PortalLayout>
      <Link to="/portal" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#0A4F35] mb-6">
        <ArrowLeft size={16} /> Back to dashboard
      </Link>
      {!order ? (
        <div className="text-center text-slate-500 py-20">Loading…</div>
      ) : (
        <div className="max-w-2xl">
          <OrderSummary order={order} onAccept={onAccept} onPay={onPay} busy={busy} shareLink={shareLink} />
        </div>
      )}
    </PortalLayout>
  );
}
